import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { FilterAttributeOption } from '@df/catalog-ui/listing/filter/filter-attribute-option';
import { Product as CoreProduct, IProductDataV2 } from '@df/catalog/product/product';
import { FacetUrlModule } from '@df/module-facet-url/facet-url.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { UiComponent } from '@df/ui/ui.component';
import { Product } from '../../../catalog/product/product.decorator';
import { ProductListing } from '../product-listing.decorator';
@Component({
    selector: 'filter-prerender-links',
    templateUrl: './filter-prerender-links.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [FacetUrlModule, HrefComponent]
})
export class FilterPrerenderLinksComponent extends UiComponent implements OnInit, OnDestroy {
    @Input()
    listing?: ProductListing<Product<IProductDataV2>>;

    override ngOnChanges(changes: any): void {
        if (changes.listing) {
            this.detectChanges();
        }
    }

    options(filter) {
        return filter.options;
    }
    asFilterAttributeOption(filter) {
        return filter as FilterAttributeOption<CoreProduct<IProductDataV2>>;
    }
}
